import { FC, useState } from 'react';
import { Banknote, Check, Copy, CreditCard, Wallet } from 'lucide-react';
import Button from 'shared/components/Button';
import PaymentCard from 'shared/components/payment-card/PaymentCard';
import {
  Payment,
  TypePaymentStatus
} from '../models/TransferReservationPartial';
import PaymentStatusHistory from './PaymentStatusHistory';
import { getPaymentStatusConfig } from '../constants/paymentStatusColors';
import { SectionCardHeader, sectionCardClass } from './detailUi';

interface ViajeTrasladoMedioDePagoDetailProps {
  payment: Payment | undefined;
}

const ViajeTrasladoMedioDePagoDetail: FC<
  ViajeTrasladoMedioDePagoDetailProps
> = ({ payment }) => {
  const [copied, setCopied] = useState(false);

  if (!payment) {
    return (
      <div className={sectionCardClass}>
        <p className="text-sm text-inkMuted dark:text-inkMuted-dark">
          No hay datos de pago para mostrar.
        </p>
      </div>
    );
  }

  const handleCopyToClipboard = () => {
    if (payment?.payment_gateway_id) {
      navigator.clipboard.writeText(payment.payment_gateway_id.toString());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const paymentMethod = payment.states.find(
    (state) => state.status_name === TypePaymentStatus.PAID
  )
    ? 'Pago manual'
    : payment.payment_method;

  const status = payment.states[0].status_name;
  const statusConfig = getPaymentStatusConfig(status);

  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div className={sectionCardClass}>
          <SectionCardHeader icon={Wallet} title="Estado del pago" />
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <span className="text-sm font-medium text-ink dark:text-ink-dark">
                Monto:
              </span>
              <span
                className="text-base font-semibold"
                style={{ color: statusConfig.color }}
              >
                {payment.amount ? `$${payment.amount}` : '-'}
              </span>
            </div>
            <div className="flex flex-wrap items-center gap-4">
              <div className="flex items-center gap-3">
                <span className="text-sm font-medium text-ink dark:text-ink-dark">
                  Estado:
                </span>
                <span
                  className="text-sm font-semibold"
                  style={{ color: statusConfig.color }}
                >
                  {statusConfig.text}
                </span>
              </div>
              {payment.states && payment.states.length > 0 && (
                <PaymentStatusHistory statusHistory={payment.states} />
              )}
            </div>
            {statusConfig.text === 'Pagado' && payment.payment_gateway_id && (
              <Button
                variant="secondary"
                size="sm"
                icon={copied ? Check : Copy}
                onClick={handleCopyToClipboard}
                className="self-start"
              >
                {copied ? '¡Copiado!' : 'Copiar ID de pago'}
              </Button>
            )}
          </div>
        </div>

        <div className={sectionCardClass}>
          <SectionCardHeader icon={Banknote} title="Medio de pago" />
          <span className="text-sm capitalize text-ink dark:text-ink-dark">
            {paymentMethod.toLowerCase()}
          </span>
        </div>
      </div>

      <div className={sectionCardClass}>
        <SectionCardHeader icon={CreditCard} title="Detalle de la Tarjeta" />
        <PaymentCard payment={payment} />
      </div>
    </div>
  );
};

export default ViajeTrasladoMedioDePagoDetail;
